import { forwardRef, useState } from "react";
import {
  Container,
  DropdownContainer,
  ListContainer,
  MeetingRoomListContainer,
  SelectedContainer,
} from "./MeetingRoomFilterDropdown.styles";
import { TMeetingRoom } from "apis/meetings/meeting-room";
import UI from "@mile-meeting/mile-ui";
import DropdownItem from "uis/Filters/DropdownItem/DropdownItem";

type MeetingRoomFilterDropdownProps = {
  open?: boolean;
  meetingRoomList: TMeetingRoom[];
  onChange?: (value: TMeetingRoom[]) => void;
  value?: TMeetingRoom[];
};

const MeetingRoomFilterDropdown = forwardRef<HTMLDivElement, MeetingRoomFilterDropdownProps>(
  ({ open, meetingRoomList, onChange, value }, ref) => {
    const [searchValue, setSearchValue] = useState<string>("");

    //* INFO: 특정 회의실 삭제시
    const handleRemoveFilter = (index: number) => {
      if (value) onChange?.(value.filter((_, i) => i !== index));
    };

    //* INFO: 전체 회의실 선택 시
    const handleSelectAllMeetingRoom = () => {
      onChange?.([
        {
          name: "전체 회의실",
          id: "",
          capacity: 0,
          description: "",
          isInsideTabletUsed: false,
          isOutsideTabletUsed: false,
          isBlocked: false,
          building: {
            id: "",
            name: "",
            provider: "MILE",
          },
          floor: {
            id: "",
            name: "",
          },
          image: "",
          meetingRoomIntegration: {
            id: "",
            integrationProvider: "MILE",
            resourceName: "",
            capacity: 0,
            description: "",
            privateMeetingDataCollected: false,
          },
        },
      ]);
    };

    //* INFO: 회의실 선택 시
    const handleSelectMeetingRoom = (data: TMeetingRoom) => {
      if (value && value.includes(data)) return;
      if ((value && value.length === 0) || (value && value?.[0].id === "")) {
        onChange?.([data]);
      } else value && onChange?.([...value, data]);
    };

    return (
      <Container
        ref={ref}
        style={{
          display: open ? "flex" : "none",
        }}
      >
        <SelectedContainer>
          {value?.map((data, index) => (
            <UI.Chip.Contained
              key={index}
              onClick={() => handleRemoveFilter(index)}
              title={data.name}
              rightIcon="x"
              showRightIcon
              size="small"
              type="secondary"
            />
          ))}
        </SelectedContainer>
        <DropdownContainer>
          <MeetingRoomListContainer>
            <UI.Input
              width={188}
              placeholder="회의실명 검색"
              size="small"
              style={{ margin: "6px" }}
              onChange={setSearchValue}
            />
            <ListContainer>
              <DropdownItem placeholder="전체 회의실" onClick={handleSelectAllMeetingRoom} />
              {meetingRoomList
                .filter((item) => item.name.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()))
                .map((data, index) => (
                  <DropdownItem
                    key={index}
                    onClick={() => {
                      handleSelectMeetingRoom(data);
                    }}
                    label={data.name}
                    selected={false}
                  />
                ))}
            </ListContainer>
          </MeetingRoomListContainer>
        </DropdownContainer>
      </Container>
    );
  }
);

export default MeetingRoomFilterDropdown;
